import { Link, useForm } from '@inertiajs/inertia-react'
import { useDebouncedCallback } from 'app/components/hooks/useDebouncedCallback'
import Icon from 'app/components/Icon'
import Img from 'app/components/Image'
import Layout from 'app/components/Layouts/Layout'
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals'
import { NoteType } from 'app/components/Types/NoteType'
import { TaskType } from 'app/components/Types/TaskType'
import Checkbox from 'app/fragments/Forms/Checkbox'
import Form from 'app/fragments/Forms/Form'
import Group from 'app/fragments/Forms/Group'
import TextField from 'app/fragments/Forms/TextField'
import IconText from 'app/fragments/IconText'
import { UserAvatar } from 'app/fragments/UserAvatar'
import moment, { duration } from 'moment'
import React, { useContext, useEffect } from 'react'
import route from 'ziggy-js'

interface Props {
    task: TaskType
}


function NoteRow({ note, task_id }: { note: NoteType, task_id: number }) {
    const form = useForm({
        id: note.id,
        text: note.text,
        completed: note.completed
    });

    const { data, post, isDirty,  } = form;

    const submit = (e) => {
        post(route('notes.update', { note: note.id, task: task_id }), { only: ['task'], preserveScroll: true, preserveState: false  });
    }

    const fnc = useDebouncedCallback((e) => {
        submit(e);
    }, 300);

    useEffect(() => {
        if(isDirty)
            fnc();
    }, [data])


    return (
        <Form form={form}>
            <div className='flex gap-16px items-center'>
                <Checkbox name={`completed`} />
                <TextField name={`text`} />
            </div>
        </Form>
    );
}


function Detail(props: Props) {
    const { task } = props
    const { open } = useContext(ModalsContext)

    let estimate = duration(task.estimate);
    let u_estimate = duration(task.upper_estimate);

    const form = useForm({});
    const { data, post, isDirty, processing } = form;

    const submit = (e) => {
        e?.preventDefault();

        if(isDirty && !processing)
            post(route('notes.store', {task: task.id }), { only: ['task'], preserveScroll: true, preserveState: false });
    }

    const fnc = useDebouncedCallback((e) => {
        submit(e);
    }, 300);

    useEffect(() => {
        if(data['text'])
            fnc();
    }, [data])

    return (
        <Layout heading='Task'>
            <div className='mt-40px mb-24px'>
                <Link href={route('tasks.index')} className="bg-gray-1C1C1C rounded-full w-55px h-55px flex items-center justify-center text-white"><Icon className='rotate-180' name="arrow-right" /></Link>
            </div>
            <div className='flex justify-between mob:flex-col mob:gap-6px'>
                <h2 className='text-24 font-bold'>{task.name}</h2>
                <div className="flex gap-8px items-center">
                    <Icon name="target" />
                    <div className="text-14">{moment(task.deadline, 'D. M. YYYY H:i').format('D. M. YYYY')}</div>
                </div>
            </div>
            <div className='flex justify-between mt-16px mob:flex-col'>
                <div className="flex gap-16px mt-10px items-center mob:mt-0">
                    <div className="bg-gray-343434 p-8px text-white font-medium rounded-full text-12">{task.project.name}</div>
                    <div className="flex">
                        {
                            task?.users?.slice(0, 3).map(u =>
                                <UserAvatar user={u} />
                            )
                        }
                        {
                            (task?.users?.length > 3) &&
                            <div className="rounded-full h-32px w-32px border-2 border-gray-1C1C1C bg-gray-343434 -mx-4px flex items-center justify-center overflow-hidden"
                                title={task?.users?.slice(3).reduce((p, c, i) => `${p}${i > 0 ? ', ' : ''}${c.name}`, '')}
                            >
                                +{task.users.length - 3}
                            </div>
                        }
                    </div>
                    <a className="cursor-pointer" onClick={() => open(MODALS.EDITTASK, false, { task: task })}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Edit" /></a>
                </div>
                <div className='flex items-center mob:mt-12px'>
                    <div className="flex gap-8px items-center">
                        <div className="text-14">{`${(Math.floor(estimate.asHours()))}h ${(estimate.minutes())}m`} <span className=" text-white/50">/ {`${(Math.floor(u_estimate.asHours()))}h ${(u_estimate.minutes())}m`}</span></div>
                    </div>
                </div>
            </div>

            <div className='mt-32px'>
                <Form form={form} onSubmit={submit}>
                    <div>New note</div>
                    <div className='flex gap-16px items-center'>
                        {/* <Checkbox name={`completed`} /> */}
                        <TextField name={`text`} />
                    </div>
                </Form>
            </div>
            <div className='mt-32px'>
                <Form form={form}>
                    {
                        task?.notes?.map(n =>
                            <NoteRow note={n} task_id={task.id} />
                        )
                    }
                </Form>
            </div>
        </Layout>
    )
}

export default Detail
